import React, { useEffect } from "react";
import { storageApi } from "../storage/storageApi";
import { appRoutes, useAppNavigation } from "../router/routes";

const DispatcherPage = () => {
  const isUserLogin = storageApi.useIsUserLogin();
  const { navigate } = useAppNavigation();

  useEffect(() => {
    navigate(isUserLogin ? appRoutes.dashboard : appRoutes.authLogin);
  }, [isUserLogin, navigate]);

  return <div>loading ...</div>;
};

export default DispatcherPage;
